/* eslint-env browser, node */
// Ensures `process` exists before any lazy-loaded chunk runs (some deps read it at runtime).
// DefinePlugin inlines `process.env.NODE_ENV` in this file; duplicate onto `window` for
// code paths that reference `process` before the webpack runtime injects ProvidePlugin.
const node_env =
    typeof process !== 'undefined' && process.env && process.env.NODE_ENV
        ? process.env.NODE_ENV
        : 'development';

const ensure_process = (target) => {
    if (!target || typeof target !== 'object') {
        return;
    }
    if (typeof target.process === 'undefined') {
        target.process = { env: { NODE_ENV: node_env } };
    } else if (!target.process.env) {
        target.process.env = { NODE_ENV: node_env };
    } else if (typeof target.process.env.NODE_ENV === 'undefined') {
        target.process.env.NODE_ENV = node_env;
    }
};

if (typeof window !== 'undefined') {
    ensure_process(window);
}
